export default __webpack_public_path__ + "static/media/grs_2.ad17d63e.jpg";